import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  selectBroadcasts,
  selectSentMessages,
  selectReceivedMessages,
  selectEmails,
  selectSms,
} from '../../selectors/messagesSelector'
import {
  FETCH_SINGLE_MESSAGE_REQUEST,
  SET_SEEN_STATUS_REQUEST,
  FETCH_SINGLE_BROADCAST_REQUEST,
  FETCH_SINGLE_EMAIL_REQUEST,
  FETCH_SINGLE_SMS_REQUEST,
} from '../../actions/actions'
import moment from 'moment-jalaali'
import { toPersianDigit } from '../../helpers/nums'
import { Well } from '@sketchpixy/rubix'
import { BounceLoader } from 'halogen'
import { Link } from 'react-router'

const styles = {
  spinner: {
    display: 'flex',
    height: '60vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
}

class ReadMessage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: null,
      aSyncCall: false,
    }
  }

  componentWillMount = () => {
    const {
      params: { messageId, type },
      userType,
      dispatch,
    } = this.props
    // first checks local state, then global state, if it doesn't exists
    // then fires the appropriate fetch request
    if (!this.state.message) {
      const message = this.selectMessage(this.props)

      if (message) {
        if (userType !== 'MANAGER') {
          this.handleSeenStatus(message.seen)
        }
        this.setState({ message })
        return
      }

      this.setState({ aSyncCall: true })

      new Promise(resolve => {
        if (type === 'broadcasted' || type === 'broadcast') {
          dispatch({
            type: FETCH_SINGLE_BROADCAST_REQUEST,
            broadcastId: messageId,
            resolve,
          })
        } else if (type === 'email') {
          dispatch({
            type: FETCH_SINGLE_EMAIL_REQUEST,
            emailId: messageId,
            resolve,
          })
        } else if (type === 'sms') {
          dispatch({
            type: FETCH_SINGLE_SMS_REQUEST,
            smsId: messageId,
            resolve,
          })
        } else {
          dispatch({
            type: FETCH_SINGLE_MESSAGE_REQUEST,
            messageId,
            resolve,
          })
        }
      })
        .then(message => {
          this.setState({ message, aSyncCall: false })
          this.handleSeenStatus(message.seen)
        })
        .catch()
    }
  }

  handleSeenStatus = isSeen => {
    if (isSeen === false) {
      const {
        params: { messageId, type },
        dispatch,
      } = this.props

      dispatch({ type: SET_SEEN_STATUS_REQUEST, messageId, messageType: type })
    }
  }

  selectMessage = ({
    receivedMessages,
    sentMessages,
    broadcastedMessages,
    emails,
    smsMessages,
    params: { type, messageId },
  }) => {
    if (type === 'sent') {
      return sentMessages.entities.messages[messageId]
    } else if (type === 'received') {
      return receivedMessages.entities.messages[messageId]
    } else if (type === 'broadcasted') {
      return broadcastedMessages.entities.broadcasts[messageId]
    } else if (type === 'broadcast') {
      return broadcastedMessages.entities.broadcasts[messageId]
    } else if (type === 'email') {
      return emails.entities.emails[messageId]
    } else if (type === 'sms') {
      return smsMessages.entities.smsMessages[messageId]
    } else {
      return {}
    }
  }

  render() {
    const { aSyncCall, message } = this.state
    const {
      params: { type: messageType },
      userType,
    } = this.props
    if (aSyncCall) {
      return (
        <div style={styles.spinner}>
          <BounceLoader color={'#00abde'} />
        </div>
      )
    }

    const senderName =
      userType !== 'MANAGER' || !message.sender
        ? 'مدیریت'
        : `${message.sender.first_name} ${message.sender.last_name} `

    return (
      <div>
        <Well>
          {`تاریخ ارسال: ${toPersianDigit(
            moment(message.sent_at).format('jYYYY.jM.jD در ساعت HH:mm')
          )}`}
        </Well>

        <section className="message-page">
          <div>
            <span>
              <span>فرستنده:</span>
              <span style={{ paddingRight: '10px' }}>{senderName}</span>
            </span>

            <span>
              {userType === 'MANAGER' &&
                messageType === 'received' && (
                  <Link
                    to={`/dashboard/manager-${message.sender.user_type}s/view/${
                      message.sender.id
                    }`}
                  >
                    {message.sender.username}
                  </Link>
                )}
            </span>
          </div>

          <h4>پیام:</h4>

          <p style={{ paddingRight: '10px' }}>{message.text}</p>
        </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...selectReceivedMessages(state),
    ...selectSentMessages(state),
    ...selectBroadcasts(state),
    ...selectEmails(state),
    ...selectSms(state),
    userType: state.auth.userType,
  }
}

export default connect(mapStateToProps)(ReadMessage)



// WEBPACK FOOTER //
// ./src/components/common/ReadMessage.js